// extracted by mini-css-extract-plugin
export default {"infoContainer":"ChannelInfo_infoContainer__51gfu","title":"ChannelInfo_title__NlecN","name":"ChannelInfo_name__-E8xC","description":"ChannelInfo_description__BrFii"};